import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

type IconProps = SvgIconProps & {
  lightMode?: boolean;
};

export const AzureIcon = (props: SvgIconProps) => (
  <SvgIcon width="150" height="150" viewBox="0 0 96 96" {...props}>
    <defs>
      <linearGradient
        id="e399c19f-b68f-429d-b176-18c2117ff73c"
        x1="-1032.172"
        x2="-1059.213"
        y1="145.312"
        y2="65.426"
        gradientTransform="matrix(1 0 0 -1 1075 158)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#114a8b" />
        <stop offset="1" stopColor="#0669bc" />
      </linearGradient>
      <linearGradient
        id="ac2a6fc2-ca48-4327-9a3c-d4dcc3256e15"
        x1="-1023.725"
        x2="-1029.98"
        y1="108.083"
        y2="105.968"
        gradientTransform="matrix(1 0 0 -1 1075 158)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopOpacity=".3" />
        <stop offset=".071" stopOpacity=".2" />
        <stop offset=".321" stopOpacity=".1" />
        <stop offset=".623" stopOpacity=".05" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="a7fee970-a784-4bb1-af8d-63d18e5f7db9"
        x1="-1027.165"
        x2="-997.482"
        y1="147.642"
        y2="68.561"
        gradientTransform="matrix(1 0 0 -1 1075 158)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#3ccbf4" />
        <stop offset="1" stopColor="#2892df" />
      </linearGradient>
    </defs>
    <path
      fill={props?.color ?? 'url(#e399c19f-b68f-429d-b176-18c2117ff73c)'}
      d="M33.338 6.544h26.038l-27.03 80.087a4.152 4.152 0 0 1-3.933 2.824H8.149a4.145 4.145 0 0 1-3.928-5.47L29.404 9.368a4.152 4.152 0 0 1 3.934-2.825z"
    />
    <path
      fill={props?.color ?? '#0078d4'}
      d="M71.175 60.261h-41.29a1.911 1.911 0 0 0-1.305 3.309l26.532 24.764a4.171 4.171 0 0 0 2.846 1.121h23.38z"
    />
    <path
      fill={props?.color ?? 'url(#ac2a6fc2-ca48-4327-9a3c-d4dcc3256e15)'}
      d="M33.338 6.544a4.118 4.118 0 0 0-3.943 2.879L4.252 83.917a4.14 4.14 0 0 0 3.908 5.538h20.787a4.443 4.443 0 0 0 3.41-2.9l5.014-14.777 17.91 16.705a4.237 4.237 0 0 0 2.666.972H81.24L71.024 60.261l-29.781.007L59.47 6.544z"
    />
    <path
      fill={props?.color ?? 'url(#a7fee970-a784-4bb1-af8d-63d18e5f7db9)'}
      d="M66.595 9.364a4.145 4.145 0 0 0-3.928-2.82H33.648a4.146 4.146 0 0 1 3.928 2.82l25.184 74.62a4.146 4.146 0 0 1-3.928 5.472h29.02a4.146 4.146 0 0 0 3.927-5.472z"
    />
  </SvgIcon>
);

export const AzureDevOpsIcon = (props: SvgIconProps) => (
  <SvgIcon width="18" height="18" viewBox="0 0 18 18" {...props}>
    <defs>
      <linearGradient
        id="ba420277-700e-42cc-9de9-5388a5c16e54"
        x1="9"
        y1="16.97"
        x2="9"
        y2="1.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <title>Icon-devops-261</title>
    <path
      id="a91f0ca4-8fb7-4019-9c09-0a52e2c05754"
      d="M17,4v9.74l-4,3.28-6.2-2.26V17L3.29,12.41l10.23.8V4.44Zm-3.41.49L7.85,1V3.29L2.58,4.84,1,6.87v4.61l2.26,1V6.57Z"
      fill="url(#ba420277-700e-42cc-9de9-5388a5c16e54)"
    />
  </SvgIcon>
);

export const SlackLogoIcon = (props: IconProps) => (
  <SvgIcon {...props} viewBox="0 0 2447.6 2452.5">
    <g clipRule="evenodd" fillRule="evenodd">
      <path
        d="m897.4 0c-135.3.1-244.8 109.9-244.7 245.2-.1 135.3 109.5 245.1 244.8 245.2h244.8v-245.1c.1-135.3-109.5-245.1-244.9-245.3.1 0 .1 0 0 0m0 654h-652.6c-135.3.1-244.9 109.9-244.8 245.2-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3z"
        fill="currentColor"
      />
      <path
        d="m2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3zm-652.7 0v-654c.1-135.2-109.4-245-244.7-245.2-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3z"
        fill="currentColor"
      />
      <path
        d="m1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2zm0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3z"
        fill="currentColor"
      />
      <path
        d="m0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2v-245.2h-244.8c-135.3.1-244.9 109.9-244.8 245.2zm652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
);

export const MenuBookIcon = (props: IconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="#fff"
    width="24px"
    height="24px"
  >
    <path
      fill={props.lightMode ? '#fff' : ''}
      d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
    />
  </SvgIcon>
);

export const SupportIcon = (props: IconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    width="48px"
    height="48px"
  >
    <path fill="none" d="M0 0h48v48H0z" />
    <path
      fill={props.lightMode ? '#fff' : ''}
      d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm2 34h-4v-4h4v4zm4.13-15.49-1.79 1.84C26.9 25.79 26 27 26 30h-4v-1c0-2.21.9-4.21 2.34-5.66l2.49-2.52C27.55 20.1 28 19.1 28 18c0-2.21-1.79-4-4-4s-4 1.79-4 4h-4c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.76-.71 3.35-1.87 4.51z"
    />
  </SvgIcon>
);

export const EmailIcon = (props: IconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="#fff"
    width="24px"
    height="24px"
  >
    <path
      fill={props.lightMode ? '#fff' : ''}
      d="M12 13.1L3.5 6h17L12 13.1zm0 2.2L3.5 8v10h17V8L12 15.3z"
    />
  </SvgIcon>
);

export const UpdatesIcon = (props: IconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill={props.lightMode ? '#fff' : ''}
      d="M5 19V13.4615H3.66667C2.93333 13.4615 2.30556 13.1904 1.78333 12.6481C1.26111 12.1058 1 11.4538 1 10.6923V7.92308C1 7.16154 1.26111 6.50962 1.78333 5.96731C2.30556 5.425 2.93333 5.15385 3.66667 5.15385H9L15.6667 1V17.6154L9 13.4615H7.66667V19H5ZM17 13.9462V4.66923C17.6 5.22308 18.0833 5.89808 18.45 6.69423C18.8167 7.49038 19 8.36154 19 9.30769C19 10.2538 18.8167 11.125 18.45 11.9212C18.0833 12.7173 17.6 13.3923 17 13.9462Z"
    />
  </SvgIcon>
);
// For this logo, the svg element is required. SvgIcon does not render the outline as expected.
export const XelerateLogoIconMono = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 17.2096H15.2372L8.99286 10.0109L15.2372 2.81216H17.5L11.2556 10.0109L17.5 17.2096Z"
      stroke="currentColor"
      strokeWidth="0.971195"
      strokeMiterlimit="8"
    />
    <path
      d="M4.57227 2.89261L10.4756 10L4.57227 17.1075H3.33594L9.03125 10.251L9.23926 10L9.03125 9.74905L3.33594 2.89261H4.57227Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.784804"
    />
  </svg>
);

export const TemplatesIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.1707 17.2V2.8C14.6537 2.8 15.0671 2.97625 15.411 3.32875C15.7549 3.68125 15.9268 4.105 15.9268 4.6V15.4C15.9268 15.895 15.7549 16.3188 15.411 16.6713C15.0671 17.0238 14.6537 17.2 14.1707 17.2ZM2.7561 19C2.27317 19 1.85976 18.8238 1.51585 18.4713C1.17195 18.1188 1 17.695 1 17.2V2.8C1 2.305 1.17195 1.88125 1.51585 1.52875C1.85976 1.17625 2.27317 1 2.7561 1H10.6585C11.1415 1 11.5549 1.17625 11.8988 1.52875C12.2427 1.88125 12.4146 2.305 12.4146 2.8V17.2C12.4146 17.695 12.2427 18.1188 11.8988 18.4713C11.5549 18.8238 11.1415 19 10.6585 19H2.7561ZM17.6829 15.4V4.6C18.0488 4.6 18.3598 4.73125 18.6159 4.99375C18.872 5.25625 19 5.575 19 5.95V14.05C19 14.425 18.872 14.7438 18.6159 15.0063C18.3598 15.2688 18.0488 15.4 17.6829 15.4Z"
    />
  </SvgIcon>
);

export const DocsIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.39999 15.4H13.6V13.6H6.39999V15.4ZM6.39999 11.8H13.6V10H6.39999V11.8ZM4.59999 19C4.10499 19 3.68124 18.8238 3.32874 18.4713C2.97624 18.1188 2.79999 17.695 2.79999 17.2V2.8C2.79999 2.305 2.97624 1.88125 3.32874 1.52875C3.68124 1.17625 4.10499 1 4.59999 1H11.8L17.2 6.4V17.2C17.2 17.695 17.0237 18.1188 16.6712 18.4713C16.3187 18.8238 15.895 19 15.4 19H4.59999ZM10.9 7.3H15.4L10.9 2.8V7.3Z"
    />
  </SvgIcon>
);
export const ResourceIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M4 18H20V15H4V18ZM5.6 15.75H7.2V17.25H5.6V15.75ZM4 6V9H20V6H4ZM7.2 8.25H5.6V6.75H7.2V8.25ZM4 13.5H20V10.5H4V13.5ZM5.6 11.25H7.2V12.75H5.6V11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const DotIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
    {...props}
  >
    <circle cx="2" cy="2" r="2" fill="currentColor" />
  </svg>
);

export const NoResultDarkIcon = () => (
  <svg
    width="105"
    height="80"
    viewBox="0 0 105 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.5035 72.6593C52.9854 72.6593 53.3761 72.2686 53.3761 71.7867C53.3761 71.3047 52.9854 70.9141 52.5035 70.9141C52.0215 70.9141 51.6309 71.3047 51.6309 71.7867C51.6309 72.2686 52.0215 72.6593 52.5035 72.6593Z"
      fill="#CFCFCF"
    />
    <path
      d="M27.1523 6.96289V10.7917"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.2285 8.87988H29.0662"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.7395 31.1114C63.2867 31.1114 55.7002 30.8086 48.6035 28.8319C41.6404 26.8997 35.2472 23.151 29.5484 18.8147C25.8176 15.9921 22.425 13.7393 17.5811 14.0777C12.8423 14.3341 8.31071 16.1037 4.65214 19.1263C-1.5096 24.5223 -0.583561 34.5217 1.88292 41.5204C5.58709 52.0896 16.8599 59.4534 26.4409 64.2171C37.5088 69.7466 49.6721 72.961 61.862 74.8042C72.5471 76.4337 86.2774 77.609 95.5379 70.637C104.041 64.2171 106.374 49.5786 104.291 39.695C103.785 36.7752 102.23 34.1406 99.9187 32.2867C93.944 27.9148 85.0308 30.8353 78.317 30.9778C75.8238 31.0312 73.2861 31.0936 70.7395 31.1114Z"
      fill="#616161"
    />
    <path
      d="M58.6812 1.74522C59.1631 1.74522 59.5538 1.35454 59.5538 0.87261C59.5538 0.39068 59.1631 0 58.6812 0C58.1993 0 57.8086 0.39068 57.8086 0.87261C57.8086 1.35454 58.1993 1.74522 58.6812 1.74522Z"
      fill="#616161"
    />
    <path
      d="M29.8848 19.8213H86.3477C86.642 19.8213 86.9331 19.885 87.2002 20.0088C87.4672 20.1326 87.7043 20.3135 87.8945 20.5381C88.0847 20.7626 88.2236 21.0259 88.3018 21.3096C88.3799 21.5933 88.3951 21.8913 88.3467 22.1816V22.1826L81.1611 65.9736C81.0832 66.4516 80.8363 66.8863 80.4658 67.1982C80.0953 67.5102 79.625 67.6795 79.1406 67.6748H22.6738L22.4541 67.6621C22.2352 67.6382 22.021 67.5792 21.8203 67.4863C21.5527 67.3625 21.315 67.1817 21.124 66.957C20.9332 66.7325 20.793 66.4694 20.7139 66.1855C20.6348 65.9019 20.6189 65.6041 20.666 65.3135L27.8867 21.5225L27.8877 21.5205C27.9637 21.0459 28.2061 20.6132 28.5723 20.3018C28.9384 19.9903 29.4041 19.8202 29.8848 19.8213Z"
      fill="#5C5C5C"
      stroke="#333333"
      strokeWidth="1.14642"
    />
    <path
      d="M79.8326 18.106L46.318 3.14239C45.3301 2.70131 44.1717 3.14459 43.7307 4.13248L33.1087 27.9226C32.6676 28.9104 33.1109 30.0689 34.0988 30.5099L67.6133 45.4735C68.6012 45.9146 69.7596 45.4713 70.2007 44.4834L80.8227 20.6933C81.2637 19.7055 80.8205 18.547 79.8326 18.106Z"
      fill="#828282"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.2305 22.7123C52.1126 21.4744 53.3956 20.5797 54.8621 20.1796C56.3285 19.7795 57.8881 19.8987 59.2767 20.517C60.6653 21.1354 61.7974 22.2147 62.4811 23.5722C63.1649 24.9297 63.3583 26.4819 63.0286 27.9657"
      stroke="#333333"
      strokeWidth="0.779568"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.2568 20.1084C67.4467 20.1084 67.6005 20.2623 67.6006 20.4521C67.6006 20.6421 67.4468 20.7959 67.2568 20.7959C67.067 20.7958 66.9131 20.642 66.9131 20.4521C66.9132 20.2623 67.067 20.1085 67.2568 20.1084Z"
      fill="#BABABA"
      stroke="#333333"
      strokeWidth="1.14642"
    />
    <path
      d="M53.9717 14.1777C54.1616 14.1777 54.3154 14.3316 54.3154 14.5215C54.3154 14.7114 54.1616 14.8652 53.9717 14.8652C53.7818 14.8652 53.6279 14.7114 53.6279 14.5215C53.628 14.3317 53.7818 14.1778 53.9717 14.1777Z"
      fill="#BABABA"
      stroke="#333333"
      strokeWidth="1.14642"
    />
    <path
      d="M78.8875 68.234H22.1496C21.4592 68.2316 20.7979 67.9557 20.3106 67.4667C19.8232 66.9777 19.5496 66.3154 19.5496 65.625V25.6185C19.5413 25.2715 19.6023 24.9262 19.7292 24.603C19.856 24.2799 20.0461 23.9853 20.2882 23.7365C20.5304 23.4877 20.8197 23.2898 21.1394 23.1542C21.459 23.0187 21.8024 22.9484 22.1496 22.9473H42.8164C43.2959 22.949 43.7657 23.0829 44.1742 23.3343C44.5826 23.5856 44.9138 23.9446 45.1315 24.3719L48.0788 30.1418C48.2957 30.5698 48.6267 30.9294 49.0353 31.1808C49.4439 31.4323 49.9141 31.5658 50.3939 31.5665H78.8875C79.5771 31.5665 80.2384 31.8404 80.726 32.328C81.2136 32.8156 81.4876 33.477 81.4876 34.1665V65.625C81.4876 66.3154 81.2139 66.9777 80.7266 67.4667C80.2392 67.9557 79.5779 68.2316 78.8875 68.234Z"
      fill="#828282"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.152 32.9238C66.8742 32.9221 63.6695 33.8924 60.9433 35.7122C58.2171 37.5319 56.0918 40.1193 54.8362 43.147C53.5806 46.1748 53.2512 49.5069 53.8896 52.7218C54.528 55.9368 56.1055 58.8903 58.4226 61.2086C60.7397 63.527 63.6923 65.106 66.907 65.7462C70.1217 66.3863 73.454 66.0586 76.4824 64.8047C79.5109 63.5508 82.0994 61.4269 83.9206 58.7016C85.7418 55.9764 86.7139 52.7723 86.7139 49.4945C86.7139 45.1012 84.9693 40.8878 81.8636 37.7804C78.7579 34.6731 74.5453 32.9262 70.152 32.9238Z"
      fill="#828282"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.9414 61.5166L86.3579 65.9331"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.8569 63.7903L84.4848 65.2256C83.8697 65.869 83.8927 66.8892 84.5361 67.5043L96.4434 78.8871C97.0868 79.5022 98.107 79.4792 98.7221 78.8358L100.094 77.4005C100.709 76.7571 100.686 75.7369 100.043 75.1218L88.1355 63.739C87.4921 63.124 86.4719 63.1469 85.8569 63.7903Z"
      fill="#333333"
    />
    <path
      d="M94.6738 0.871094V4.7088"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.752 2.79688H96.5897"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoResultLightIcon = () => (
  <svg
    width="105"
    height="80"
    viewBox="0 0 105 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.5035 72.6593C52.9854 72.6593 53.3761 72.2686 53.3761 71.7867C53.3761 71.3047 52.9854 70.9141 52.5035 70.9141C52.0215 70.9141 51.6309 71.3047 51.6309 71.7867C51.6309 72.2686 52.0215 72.6593 52.5035 72.6593Z"
      fill="#CFCFCF"
    />
    <path
      d="M27.1523 6.96289V10.7917"
      stroke="#C9C9C9"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.2285 8.87988H29.0662"
      stroke="#C9C9C9"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.7395 31.1114C63.2867 31.1114 55.7002 30.8086 48.6035 28.8319C41.6404 26.8997 35.2472 23.151 29.5484 18.8147C25.8176 15.9921 22.425 13.7393 17.5811 14.0777C12.8423 14.3341 8.31071 16.1037 4.65214 19.1263C-1.5096 24.5223 -0.583561 34.5217 1.88292 41.5204C5.58709 52.0896 16.8599 59.4534 26.4409 64.2171C37.5088 69.7466 49.6721 72.961 61.862 74.8042C72.5471 76.4337 86.2774 77.609 95.5379 70.637C104.041 64.2171 106.374 49.5786 104.291 39.695C103.785 36.7752 102.23 34.1406 99.9187 32.2867C93.944 27.9148 85.0308 30.8353 78.317 30.9778C75.8238 31.0312 73.2861 31.0936 70.7395 31.1114Z"
      fill="#D9D9D9"
    />
    <path
      d="M58.6816 0.573242C58.8468 0.573473 58.9805 0.707837 58.9805 0.873047C58.9802 1.03806 58.8467 1.17164 58.6816 1.17188C58.5164 1.17188 58.3821 1.03819 58.3818 0.873047C58.3818 0.707701 58.5163 0.573242 58.6816 0.573242Z"
      fill="#C9C9C9"
      stroke="#C9C9C9"
      strokeWidth="1.14642"
    />
    <path
      d="M29.8848 19.8213H86.3477C86.642 19.8213 86.9331 19.885 87.2002 20.0088C87.4672 20.1326 87.7043 20.3135 87.8945 20.5381C88.0847 20.7626 88.2236 21.0259 88.3018 21.3096C88.3799 21.5933 88.3951 21.8913 88.3467 22.1816V22.1826L81.1611 65.9736C81.0832 66.4516 80.8363 66.8863 80.4658 67.1982C80.0953 67.5102 79.625 67.6795 79.1406 67.6748H22.6738L22.4541 67.6621C22.2352 67.6382 22.021 67.5792 21.8203 67.4863C21.5527 67.3625 21.315 67.1817 21.124 66.957C20.9332 66.7325 20.793 66.4694 20.7139 66.1855C20.6348 65.9019 20.6189 65.6041 20.666 65.3135L27.8867 21.5225L27.8877 21.5205C27.9637 21.0459 28.2061 20.6132 28.5723 20.3018C28.9384 19.9903 29.4041 19.8202 29.8848 19.8213Z"
      fill="#D9D9D9"
      stroke="#757575"
      strokeWidth="1.14642"
    />
    <path
      d="M79.8326 18.106L46.318 3.14239C45.3301 2.70131 44.1717 3.14459 43.7307 4.13248L33.1087 27.9226C32.6676 28.9104 33.1109 30.0689 34.0988 30.5099L67.6133 45.4735C68.6012 45.9146 69.7596 45.4713 70.2007 44.4834L80.8227 20.6933C81.2637 19.7055 80.8205 18.547 79.8326 18.106Z"
      fill="white"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.2305 22.7123C52.1126 21.4744 53.3956 20.5797 54.8621 20.1796C56.3285 19.7795 57.8881 19.8987 59.2767 20.517C60.6653 21.1354 61.7974 22.2147 62.4811 23.5722C63.1649 24.9297 63.3583 26.4819 63.0286 27.9657"
      stroke="#757575"
      strokeWidth="0.779568"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.2568 20.1084C67.4467 20.1084 67.6005 20.2623 67.6006 20.4521C67.6006 20.6421 67.4468 20.7959 67.2568 20.7959C67.067 20.7958 66.9131 20.642 66.9131 20.4521C66.9132 20.2623 67.067 20.1085 67.2568 20.1084Z"
      fill="#757575"
      stroke="#757575"
      strokeWidth="1.14642"
    />
    <path
      d="M53.9717 14.1777C54.1616 14.1777 54.3154 14.3316 54.3154 14.5215C54.3154 14.7114 54.1616 14.8652 53.9717 14.8652C53.7818 14.8652 53.6279 14.7114 53.6279 14.5215C53.628 14.3317 53.7818 14.1778 53.9717 14.1777Z"
      fill="#757575"
      stroke="#757575"
      strokeWidth="1.14642"
    />
    <path
      d="M78.8875 68.234H22.1496C21.4592 68.2316 20.7979 67.9557 20.3106 67.4667C19.8232 66.9777 19.5496 66.3154 19.5496 65.625V25.6185C19.5413 25.2715 19.6023 24.9262 19.7292 24.603C19.856 24.2799 20.0461 23.9853 20.2882 23.7365C20.5304 23.4877 20.8197 23.2898 21.1394 23.1542C21.459 23.0187 21.8024 22.9484 22.1496 22.9473H42.8164C43.2959 22.949 43.7657 23.0829 44.1742 23.3343C44.5826 23.5856 44.9138 23.9446 45.1315 24.3719L48.0788 30.1418C48.2957 30.5698 48.6267 30.9294 49.0353 31.1808C49.4439 31.4323 49.9141 31.5658 50.3939 31.5665H78.8875C79.5771 31.5665 80.2384 31.8404 80.726 32.328C81.2136 32.8156 81.4876 33.477 81.4876 34.1665V65.625C81.4876 66.3154 81.2139 66.9777 80.7266 67.4667C80.2392 67.9557 79.5779 68.2316 78.8875 68.234Z"
      fill="#EEEEEE"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.152 32.9238C66.8742 32.9221 63.6695 33.8924 60.9433 35.7122C58.2171 37.5319 56.0918 40.1193 54.8362 43.147C53.5806 46.1748 53.2512 49.5069 53.8896 52.7218C54.528 55.9368 56.1055 58.8903 58.4226 61.2086C60.7397 63.527 63.6923 65.106 66.907 65.7462C70.1217 66.3863 73.454 66.0586 76.4824 64.8047C79.5109 63.5508 82.0994 61.4269 83.9206 58.7016C85.7418 55.9764 86.7139 52.7723 86.7139 49.4945C86.7139 45.1012 84.9693 40.8878 81.8636 37.7804C78.7579 34.6731 74.5453 32.9262 70.152 32.9238Z"
      fill="#EEEEEE"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.9414 61.5166L86.3579 65.9331"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.8569 63.7903L84.4848 65.2256C83.8697 65.869 83.8927 66.8892 84.5361 67.5043L96.4434 78.8871C97.0868 79.5022 98.107 79.4792 98.7221 78.8358L100.094 77.4005C100.709 76.7571 100.686 75.7369 100.043 75.1218L88.1355 63.739C87.4921 63.124 86.4719 63.1469 85.8569 63.7903Z"
      fill="#757575"
    />
    <path
      d="M94.6738 0.871094V4.7088"
      stroke="#C9C9C9"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.752 2.79688H96.5897"
      stroke="#C9C9C9"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoResultDarkIcon2 = () => (
  <svg
    width="136"
    height="103"
    viewBox="0 0 136 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68.0044 93.5478C68.6248 93.5478 69.1279 93.0448 69.1279 92.4243C69.1279 91.8038 68.6248 91.3008 68.0044 91.3008C67.3839 91.3008 66.8809 91.8038 66.8809 92.4243C66.8809 93.0448 67.3839 93.5478 68.0044 93.5478Z"
      fill="#CFCFCF"
    />
    <path
      d="M35.3652 8.96484V13.8945"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.8887 11.4297H37.8298"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M91.4831 40.0555C81.8876 40.0555 72.12 39.6658 62.983 37.1207C54.018 34.633 45.7867 29.8065 38.4496 24.2234C33.6461 20.5893 29.2782 17.6888 23.0417 18.1245C16.9405 18.4546 11.106 20.733 6.39561 24.6247C-1.53763 31.572 -0.345353 44.4463 2.83024 53.4572C7.59936 67.0653 22.1131 76.5462 34.4486 82.6795C48.6986 89.7988 64.3588 93.9374 80.0533 96.3105C93.8104 98.4085 111.488 99.9217 123.411 90.9453C134.359 82.6795 137.363 63.8324 134.68 51.1071C134.029 47.3478 132.028 43.9558 129.051 41.5688C121.359 35.9399 109.883 39.7002 101.239 39.8836C98.0292 39.9524 94.7619 40.0326 91.4831 40.0555Z"
      fill="#616161"
    />
    <path
      d="M75.9594 2.24699C76.5799 2.24699 77.0829 1.74398 77.0829 1.12349C77.0829 0.503005 76.5799 0 75.9594 0C75.3389 0 74.8359 0.503005 74.8359 1.12349C74.8359 1.74398 75.3389 2.24699 75.9594 2.24699Z"
      fill="#616161"
    />
    <path
      d="M38.8838 25.3584H111.579C111.982 25.3584 112.381 25.4458 112.746 25.6152C113.112 25.7847 113.436 26.0324 113.696 26.3398C113.957 26.6471 114.147 27.0073 114.254 27.3955C114.361 27.7839 114.382 28.1915 114.315 28.5889V28.5898L105.063 84.9717C104.957 85.626 104.619 86.2205 104.112 86.6475C103.605 87.0745 102.962 87.3062 102.299 87.2998H29.5996C29.1961 87.2995 28.7968 87.2115 28.4307 87.042C28.0647 86.8725 27.7397 86.6256 27.4785 86.3184C27.2173 86.011 27.0263 85.6502 26.918 85.2617C26.8098 84.8735 26.7871 84.4662 26.8516 84.0684L36.1484 27.6875L36.1494 27.6846C36.2534 27.0347 36.5856 26.443 37.0869 26.0166C37.5882 25.5902 38.2257 25.3569 38.8838 25.3584Z"
      fill="#ADADAD"
      stroke="#333333"
      strokeWidth="1.14642"
    />
    <path
      d="M103.189 23.3116L60.0393 4.04584C58.7674 3.47795 57.276 4.04867 56.7081 5.32058L43.0323 35.9506C42.4644 37.2225 43.0351 38.7139 44.307 39.2818L87.457 58.5476C88.7289 59.1155 90.2203 58.5447 90.7882 57.2728L104.464 26.6429C105.032 25.3709 104.461 23.8795 103.189 23.3116Z"
      fill="white"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.3652 29.2455C67.501 27.6518 69.1529 26.4998 71.0409 25.9847C72.9289 25.4696 74.9369 25.6231 76.7247 26.4191C78.5125 27.2152 79.9701 28.6049 80.8505 30.3527C81.7308 32.1005 81.9799 34.099 81.5553 36.0094"
      stroke="#333333"
      strokeWidth="0.779568"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.999 25.7256C87.3345 25.7256 87.6064 25.9975 87.6064 26.333C87.6064 26.6686 87.3346 26.9404 86.999 26.9404C86.6635 26.9403 86.3916 26.6685 86.3916 26.333C86.3917 25.9976 86.6636 25.7257 86.999 25.7256Z"
      fill="#BABABA"
      stroke="#333333"
      strokeWidth="1.14642"
    />
    <path
      d="M69.8955 18.0898C70.231 18.0898 70.5028 18.3618 70.5029 18.6973C70.5029 19.0328 70.2311 19.3047 69.8955 19.3047C69.56 19.3046 69.2881 19.0328 69.2881 18.6973C69.2882 18.3618 69.5601 18.0899 69.8955 18.0898Z"
      fill="#BABABA"
      stroke="#333333"
      strokeWidth="1.14642"
    />
    <path
      d="M101.973 87.85H28.9227C28.0339 87.847 27.1824 87.4918 26.555 86.8622C25.9275 86.2326 25.5752 85.3799 25.5752 84.491V32.9822C25.5645 32.5354 25.6431 32.0909 25.8064 31.6748C25.9697 31.2587 26.2144 30.8794 26.5262 30.5591C26.8379 30.2388 27.2105 29.9839 27.622 29.8094C28.0335 29.635 28.4758 29.5444 28.9227 29.543H55.5312C56.1486 29.5452 56.7535 29.7176 57.2793 30.0412C57.8052 30.3648 58.2317 30.8271 58.5119 31.3772L62.3066 38.8061C62.5858 39.3571 63.012 39.82 63.5381 40.1438C64.0642 40.4675 64.6696 40.6394 65.2873 40.6403H101.973C102.861 40.6403 103.712 40.993 104.34 41.6208C104.968 42.2486 105.32 43.1001 105.32 43.9879V84.491C105.32 85.3799 104.968 86.2326 104.341 86.8622C103.713 87.4918 102.862 87.847 101.973 87.85Z"
      fill="#EEEEEE"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.7253 42.3945C86.5052 42.3923 82.3792 43.6416 78.8691 45.9845C75.3591 48.3275 72.6228 51.6587 71.0062 55.557C69.3897 59.4552 68.9655 63.7453 69.7875 67.8847C70.6094 72.024 72.6404 75.8266 75.6237 78.8115C78.607 81.7964 82.4085 83.8295 86.5474 84.6536C90.6863 85.4778 94.9766 85.0559 98.8757 83.4415C102.775 81.827 106.108 79.0925 108.452 75.5837C110.797 72.075 112.049 67.9496 112.049 63.7295C112.049 58.0731 109.803 52.6482 105.804 48.6474C101.805 44.6467 96.3817 42.3976 90.7253 42.3945Z"
      fill="#8AE4D4"
      fillOpacity="0.4"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M105.904 79.207L111.591 84.8933"
      stroke="#333333"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M110.948 82.1296L109.182 83.9776C108.39 84.806 108.42 86.1195 109.248 86.9114L124.579 101.567C125.407 102.359 126.721 102.329 127.512 101.501L129.279 99.6528C130.071 98.8245 130.041 97.511 129.213 96.7191L113.882 82.0636C113.054 81.2717 111.74 81.3013 110.948 82.1296Z"
      fill="#00D181"
    />
    <path
      d="M122.299 1.12305V6.06413"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M119.822 3.59961H124.763"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoResultLightIcon2 = () => (
  <svg
    width="136"
    height="103"
    viewBox="0 0 136 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68.0044 93.5478C68.6248 93.5478 69.1279 93.0448 69.1279 92.4243C69.1279 91.8038 68.6248 91.3008 68.0044 91.3008C67.3839 91.3008 66.8809 91.8038 66.8809 92.4243C66.8809 93.0448 67.3839 93.5478 68.0044 93.5478Z"
      fill="#CFCFCF"
    />
    <path
      d="M35.3652 8.96484V13.8945"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.8887 11.4297H37.8298"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M91.4831 40.0555C81.8876 40.0555 72.12 39.6658 62.983 37.1207C54.018 34.633 45.7867 29.8065 38.4496 24.2234C33.6461 20.5893 29.2782 17.6888 23.0417 18.1245C16.9405 18.4546 11.106 20.733 6.39561 24.6247C-1.53763 31.572 -0.345353 44.4463 2.83024 53.4572C7.59936 67.0653 22.1131 76.5462 34.4486 82.6795C48.6986 89.7988 64.3588 93.9374 80.0533 96.3105C93.8104 98.4085 111.488 99.9217 123.411 90.9453C134.359 82.6795 137.363 63.8324 134.68 51.1071C134.029 47.3478 132.028 43.9558 129.051 41.5688C121.359 35.9399 109.883 39.7002 101.239 39.8836C98.0292 39.9524 94.7619 40.0326 91.4831 40.0555Z"
      fill="#D9D9D9"
    />
    <path
      d="M75.9594 2.24699C76.5799 2.24699 77.0829 1.74398 77.0829 1.12349C77.0829 0.503005 76.5799 0 75.9594 0C75.3389 0 74.8359 0.503005 74.8359 1.12349C74.8359 1.74398 75.3389 2.24699 75.9594 2.24699Z"
      fill="#616161"
    />
    <path
      d="M38.8838 25.3584H111.579C111.982 25.3584 112.381 25.4458 112.746 25.6152C113.112 25.7847 113.436 26.0324 113.696 26.3398C113.957 26.6471 114.147 27.0073 114.254 27.3955C114.361 27.7839 114.382 28.1915 114.315 28.5889V28.5898L105.063 84.9717C104.957 85.626 104.619 86.2205 104.112 86.6475C103.605 87.0745 102.962 87.3062 102.299 87.2998H29.5996C29.1961 87.2995 28.7968 87.2115 28.4307 87.042C28.0647 86.8725 27.7397 86.6256 27.4785 86.3184C27.2173 86.011 27.0263 85.6502 26.918 85.2617C26.8098 84.8735 26.7871 84.4662 26.8516 84.0684L36.1484 27.6875L36.1494 27.6846C36.2534 27.0347 36.5856 26.443 37.0869 26.0166C37.5882 25.5902 38.2257 25.3569 38.8838 25.3584Z"
      fill="#D9D9D9"
      stroke="#757575"
      strokeWidth="1.14642"
    />
    <path
      d="M103.189 23.3116L60.0393 4.04584C58.7674 3.47795 57.276 4.04867 56.7081 5.32058L43.0323 35.9506C42.4644 37.2225 43.0351 38.7139 44.307 39.2818L87.457 58.5476C88.7289 59.1155 90.2203 58.5447 90.7882 57.2728L104.464 26.6429C105.032 25.3709 104.461 23.8795 103.189 23.3116Z"
      fill="white"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.3652 29.2455C67.501 27.6518 69.1529 26.4998 71.0409 25.9847C72.9289 25.4696 74.9369 25.6231 76.7247 26.4191C78.5125 27.2152 79.9701 28.6049 80.8505 30.3527C81.7308 32.1005 81.9799 34.099 81.5553 36.0094"
      stroke="#757575"
      strokeWidth="0.779568"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.999 25.7256C87.3345 25.7256 87.6064 25.9975 87.6064 26.333C87.6064 26.6686 87.3346 26.9404 86.999 26.9404C86.6635 26.9403 86.3916 26.6685 86.3916 26.333C86.3917 25.9976 86.6636 25.7257 86.999 25.7256Z"
      fill="#757575"
      stroke="#757575"
      strokeWidth="1.14642"
    />
    <path
      d="M69.8955 18.0898C70.231 18.0898 70.5028 18.3618 70.5029 18.6973C70.5029 19.0328 70.2311 19.3047 69.8955 19.3047C69.56 19.3046 69.2881 19.0328 69.2881 18.6973C69.2882 18.3618 69.5601 18.0899 69.8955 18.0898Z"
      fill="#757575"
      stroke="#757575"
      strokeWidth="1.14642"
    />
    <path
      d="M101.973 87.85H28.9227C28.0339 87.847 27.1824 87.4918 26.555 86.8622C25.9275 86.2326 25.5752 85.3799 25.5752 84.491V32.9822C25.5645 32.5354 25.6431 32.0909 25.8064 31.6748C25.9697 31.2587 26.2144 30.8794 26.5262 30.5591C26.8379 30.2388 27.2105 29.9839 27.622 29.8094C28.0335 29.635 28.4758 29.5444 28.9227 29.543H55.5312C56.1486 29.5452 56.7535 29.7176 57.2793 30.0412C57.8052 30.3648 58.2317 30.8271 58.5119 31.3772L62.3066 38.8061C62.5858 39.3571 63.012 39.82 63.5381 40.1438C64.0642 40.4675 64.6696 40.6394 65.2873 40.6403H101.973C102.861 40.6403 103.712 40.993 104.34 41.6208C104.968 42.2486 105.32 43.1001 105.32 43.9879V84.491C105.32 85.3799 104.968 86.2326 104.341 86.8622C103.713 87.4918 102.862 87.847 101.973 87.85Z"
      fill="#EEEEEE"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.7253 42.3945C86.5052 42.3923 82.3792 43.6416 78.8691 45.9845C75.3591 48.3275 72.6228 51.6587 71.0062 55.557C69.3897 59.4552 68.9655 63.7453 69.7875 67.8847C70.6094 72.024 72.6404 75.8266 75.6237 78.8115C78.607 81.7964 82.4085 83.8295 86.5474 84.6536C90.6863 85.4778 94.9766 85.0559 98.8757 83.4415C102.775 81.827 106.108 79.0925 108.452 75.5837C110.797 72.075 112.049 67.9496 112.049 63.7295C112.049 58.0731 109.803 52.6482 105.804 48.6474C101.805 44.6467 96.3817 42.3976 90.7253 42.3945Z"
      fill="#8AE4D4"
      fillOpacity="0.4"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M105.904 79.207L111.591 84.8933"
      stroke="#757575"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M110.948 82.1296L109.182 83.9776C108.39 84.806 108.42 86.1195 109.248 86.9114L124.579 101.567C125.407 102.359 126.721 102.329 127.512 101.501L129.279 99.6528C130.071 98.8245 130.041 97.511 129.213 96.7191L113.882 82.0636C113.054 81.2717 111.74 81.3013 110.948 82.1296Z"
      fill="#00D181"
    />
    <path
      d="M122.299 1.12305V6.06413"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M119.822 3.59961H124.763"
      stroke="#616161"
      strokeWidth="1.14642"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AllIcon = (props: SvgIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18C4 17.45 4.19583 16.9792 4.5875 16.5875C4.97917 16.1958 5.45 16 6 16C6.55 16 7.02083 16.1958 7.4125 16.5875C7.80417 16.9792 8 17.45 8 18C8 18.55 7.80417 19.0208 7.4125 19.4125C7.02083 19.8042 6.55 20 6 20ZM12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM18 20C17.45 20 16.9792 19.8042 16.5875 19.4125C16.1958 19.0208 16 18.55 16 18C16 17.45 16.1958 16.9792 16.5875 16.5875C16.9792 16.1958 17.45 16 18 16C18.55 16 19.0208 16.1958 19.4125 16.5875C19.8042 16.9792 20 17.45 20 18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20ZM6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12C4 11.45 4.19583 10.9792 4.5875 10.5875C4.97917 10.1958 5.45 10 6 10C6.55 10 7.02083 10.1958 7.4125 10.5875C7.80417 10.9792 8 11.45 8 12C8 12.55 7.80417 13.0208 7.4125 13.4125C7.02083 13.8042 6.55 14 6 14ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM18 14C17.45 14 16.9792 13.8042 16.5875 13.4125C16.1958 13.0208 16 12.55 16 12C16 11.45 16.1958 10.9792 16.5875 10.5875C16.9792 10.1958 17.45 10 18 10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12C20 12.55 19.8042 13.0208 19.4125 13.4125C19.0208 13.8042 18.55 14 18 14ZM6 8C5.45 8 4.97917 7.80417 4.5875 7.4125C4.19583 7.02083 4 6.55 4 6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4C6.55 4 7.02083 4.19583 7.4125 4.5875C7.80417 4.97917 8 5.45 8 6C8 6.55 7.80417 7.02083 7.4125 7.4125C7.02083 7.80417 6.55 8 6 8ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8ZM18 8C17.45 8 16.9792 7.80417 16.5875 7.4125C16.1958 7.02083 16 6.55 16 6C16 5.45 16.1958 4.97917 16.5875 4.5875C16.9792 4.19583 17.45 4 18 4C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6C20 6.55 19.8042 7.02083 19.4125 7.4125C19.0208 7.80417 18.55 8 18 8Z"
      fill="currentColor"
    />
  </svg>
);

export const MegatronIntegrationIcon = ({ lightMode = true }) => (
  <SvgIcon viewBox="0 0 20 14">
    <g clipPath="url(#clip0)">
      <path
        d="M18.1525 -0.141296C19.2468 -0.141142 20.1417 0.60243 20.1417 1.73956V11.4134C20.1415 12.5294 19.2685 13.4025 18.1525 13.4026H8.47864C7.3415 13.4026 6.59793 12.5077 6.59778 11.4134V1.73956C6.59778 1.19362 6.78074 0.718709 7.11926 0.380188C7.45778 0.0416671 7.9327 -0.141296 8.47864 -0.141296H18.1525Z"
        fill="currentColor"
        stroke={lightMode ? 'white' : '#424242'}
        strokeWidth="0.5"
      />
      <path
        d="M7.34436 0.916809H7.34534L15.0631 1.89532L15.0709 1.8963L15.2594 1.93341C16.1932 2.16729 16.9352 3.11304 16.8004 4.1922V4.19318L15.8219 11.9109C15.679 13.0489 14.673 13.7911 13.6334 13.6473V13.6483L13.6276 13.6473H13.6246V13.6463L5.80725 12.6697V12.6688C5.25987 12.6463 4.79757 12.3352 4.49768 11.952C4.18606 11.5537 3.9928 11.0125 4.06995 10.4725L5.04749 2.76349C5.1872 1.64819 6.17402 0.770684 7.34436 0.916809Z"
        fill="currentColor"
        stroke={lightMode ? 'white' : '#424242'}
      />
      <path
        d="M5.34058 3.18195L5.51733 3.20245L5.52612 3.20441L5.53589 3.20636L11.8406 4.51007H11.8396C12.6369 4.67085 13.2568 5.45998 13.1023 6.38702L13.1003 6.39777L11.9041 12.7015C11.7357 13.6732 10.7803 14.118 10.0173 13.9691V13.97L3.60425 12.7737L3.59741 12.7728C3.16631 12.6865 2.8184 12.3977 2.60034 12.0706C2.3823 11.7435 2.24947 11.3113 2.33569 10.8802L2.33667 10.8773L3.64038 4.57257H3.64136C3.78835 3.74425 4.4749 3.12632 5.34058 3.18195Z"
        fill="currentColor"
        stroke={lightMode ? 'white' : '#424242'}
      />
      <path
        d="M3.23059 5.19891C3.4555 5.11241 3.69652 5.09758 3.92297 5.12567L4.1427 5.16669L4.17981 5.17645L4.21497 5.1911L8.88879 7.14716L8.88782 7.14813C9.18694 7.25976 9.40226 7.49549 9.52356 7.73798C9.64946 7.98978 9.71039 8.3191 9.60461 8.63641L9.59875 8.65399L9.59192 8.67157L7.64075 13.3288C7.53643 13.6762 7.29953 13.9154 7.01282 14.0349C6.72738 14.1537 6.41213 14.1497 6.14661 14.0612L6.13489 14.0573L6.12415 14.0534L1.34192 12.2057L1.29016 12.1852L1.24426 12.155C1.00102 11.9927 0.805954 11.7569 0.687622 11.5007C0.571339 11.2487 0.506009 10.923 0.612427 10.6032L0.618286 10.5847L0.626099 10.5681L2.57727 5.90497C2.68382 5.55588 2.92646 5.31594 3.23059 5.19891Z"
        fill="currentColor"
        stroke={lightMode ? 'white' : '#424242'}
      />
      <path
        d="M2.98914 7.24457C3.16444 7.24457 3.30617 7.31162 3.41199 7.39105L3.50574 7.47211L6.22351 10.1899C6.39273 10.3592 6.45105 10.5805 6.45105 10.7612C6.45099 10.9418 6.39249 11.1623 6.22351 11.3315L6.2157 11.3393L3.4989 13.9477L3.49792 13.9467C3.38868 14.0536 3.21786 14.1684 2.98914 14.1684C2.75554 14.1684 2.58138 14.0497 2.47253 13.9409V13.9399L-0.237427 11.3393L-0.245239 11.3315C-0.414187 11.1623 -0.472714 10.9417 -0.472778 10.7612C-0.472778 10.5805 -0.414427 10.3592 -0.245239 10.1899L2.47253 7.47211L2.56628 7.39105C2.6721 7.31161 2.81382 7.24458 2.98914 7.24457Z"
        fill="currentColor"
        stroke={lightMode ? 'white' : '#424242'}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="13.6957" fill="currentColor" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const GAuthIcon = () => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
  >
    <path
      d="M8 20.0001C5.68333 19.4167 3.77083 18.0876 2.2625 16.0126C0.754167 13.9376 0 11.6334 0 9.10006V3.00006L8 6.10352e-05L16 3.00006V9.10006C16 11.6334 15.2458 13.9376 13.7375 16.0126C12.2292 18.0876 10.3167 19.4167 8 20.0001ZM8 17.9001C9.61667 17.4001 10.9667 16.4126 12.05 14.9376C13.1333 13.4626 13.7667 11.8167 13.95 10.0001H8V2.12506L2 4.37506V9.55006C2 9.66673 2.01667 9.81673 2.05 10.0001H8V17.9001Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export const appIconMapping = {
  azure: AzureIcon,
  azuredevops: AzureDevOpsIcon,
  slack: SlackLogoIcon,
  menuBook: MenuBookIcon,
};
